<ng-container *ngFor="let alert of alertNotifications">
  <img src="../../../../assets/images/notif-bull.png" alt="">
  <div class="alert alert-{{ alert.type.toString().toLowerCase() }}" role="alert">{{ alert.message }} gggg</div>
</ng-container>
